export default "__VITE_ASSET__DImzGiYr__"